import { helpers } from 'veritone-redux-common';
import { isEmpty } from 'lodash';
import { ADD_ADVERTISER, REMOVE_ADVERTISER, UPDATE_ADVERTISER } from './advertiser';
const { createReducer } = helpers;

export const FETCH_FOLDERS = 'fetch folders';
export const ADD_FOLDER = 'add folder';
export const EDIT_FOLDER = 'edit folder new';
export const DELETE_FOLDER = 'delete folder';
export const ADD_FOLDER_SAGA = 'add folder saga';
export const ADD_FOLDER_AND_ADVERISER_SAGA = 'add folder and advertiser saga';
export const EDIT_FOLDER_SAGA = 'edit folder saga';
export const FETCH_FOLDERS_SAGA = 'fetch folder saga'
export const DELETE_FOLDER_SAGA = 'delete folder saga';
export const REMOVE_ADVERTISER_IN_FOLDER = 'remove advertiser in folder'
export const LOADING_FOLDER = 'loading folder';
export const LOADED_FOLDER = 'loaded folder';
export const TOGGLE_FOLDER_MODAL = 'toggle folder modal';
export const EDITING_FOLDER_SAGA = 'editing folder'
export const LOADING_SINGLE_FOLDER = 'loading single folder'
export const LOADED_SINGLE_FOLDER = 'loaded single folder'


const defaultState = {
    loading: false,
    loaded: false,
    byId: {},
    allIds: []
};

const folderReducer = createReducer(defaultState, {
    [TOGGLE_FOLDER_MODAL]: (state, action) => ({
        ...state,
        modalOpen: action.payload.open,
        byId: {
            ...state.byId,
            'editing': {
                ...state.byId[action.payload.folder_id],
                currentFolderId: action.payload.folder_id,
                folder_id: 'editing'
            }
        }
    }),

    [LOADING_FOLDER]: (state, action) => ({
        ...state,
        loading: true,
        loaded: false
    }),
    [LOADED_FOLDER]: (state, action) => ({
        ...state,
        loading: false,
        loaded: true
    }),
    [FETCH_FOLDERS]: (state, action) => {
        const { folders } = action.payload;
        return folders.reduce((folderState, folder) => {
            const { folder_id, advertisers } = folder;
            folderState.byId[folder_id] = {
                ...folder,
                advertisers: advertisers.map(advertiser => advertiser.advertiser_id)
            }
            folderState.allIds = [
                ...folderState.allIds,
                folder_id
            ];
            return folderState;
        }, {
                byId: {},
                allIds: []
            });
    },

    [ADD_FOLDER]: (state, action) => {
        const { folder: { folder_id, ...data } } = action.payload;
        return {
            ...state,
            byId: {
                ...state.byId,
                [folder_id]: {
                    folder_id: folder_id,
                    ...data,
                    advertisers: []
                }
            },
            allIds: [
                ...state.allIds,
                folder_id
            ],
        }
    },

    [EDIT_FOLDER]: (state, action) => {
        const { folder } = action.payload;
        return {
            ...state,
            byId: {
                ...state.byId,
                [folder.folder_id]: {
                    ...state.byId[folder.folder_id],
                    ...folder,
                    advertisers: state.byId[folder.folder_id].advertisers
                }
            }
        }
    },

    [DELETE_FOLDER]: (state, action) => {
        const { folder_id } = action.payload.folder;
        const newFolderByIdState = { ...state.byId };
        delete newFolderByIdState[folder_id];
        return {
            ...state,
            byId: {
                ...newFolderByIdState
            },
            allIds: state.allIds.filter(id => id != folder_id)
        }
    },

    [ADD_ADVERTISER]: (state, action) => {
        const { advertiser } = action.payload;
        if (!advertiser.folder_id || advertiser.advertiser_id === 'editing') {
            return state;
        }
        const advertisers = Object.values(state.byId);
        if (isEmpty(advertisers)) {
            return state;
        }
        return {
            ...state,
            byId: {
                ...state.byId,
                [advertiser.folder_id]: {
                    ...state.byId[advertiser.folder_id],
                    advertisers: [
                        ...state.byId[advertiser.folder_id].advertisers,
                        advertiser.advertiser_id
                    ]
                }
            }
        }
    },

    [REMOVE_ADVERTISER]: (state, action) => {
        const { advertiser } = action.payload;
        const { folder_id, advertiser_id } = advertiser;
        const advertisers = Object.values(state.byId);
        if (isEmpty(advertisers)) {
            return state;
        }

        if (folder_id) {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [folder_id]: {
                        ...state.byId[folder_id],
                        advertisers: state.byId[folder_id].advertisers.filter(
                            advertiserId => advertiserId !== advertiser_id
                        )
                    }
                }
            }
        }
        else {
            return state
        }
    },

    [REMOVE_ADVERTISER_IN_FOLDER]: (state, action) => {
        const { advertiser } = action.payload;
        return {
            ...state,
            byId: {
                ...state.byId,
                [advertiser.folder_id]: {
                    ...state.byId[advertiser.folder_id],
                    advertisers: state.byId[advertiser.folder_id].advertisers.filter(
                        advertiserId => advertiserId !== advertiser.advertiser_id
                    )
                }
            }
        }
    },
    [UPDATE_ADVERTISER]: (state, action) => {
        const { advertiser, oldAdvertiser } = action.payload;
        if (!oldAdvertiser || advertiser.advertiser_id === 'editing') {
            return state
        }
        const { folder_id: prefolder_id } = oldAdvertiser;
        if (!prefolder_id || prefolder_id === advertiser.folder_id) {
            return state
        }
        const advertisers = Object.values(state.byId);
        if (isEmpty(advertisers)) {
            return state;
        }

        return {
            ...state,
            byId: {
                ...state.byId,
                [prefolder_id]: {
                    ...state.byId[prefolder_id],
                    advertisers: state.byId[prefolder_id].advertisers.filter(advertiserId => advertiserId !== advertiser.advertiser_id)
                },
                [advertiser.folder_id]: {
                    ...state.byId[advertiser.folder_id],
                    advertisers: [...state.byId[advertiser.folder_id].advertisers, advertiser.advertiser_id]
                }
            }
        }
    },
    [LOADING_SINGLE_FOLDER]: (state, action) => {
        const { folder_id } = action.payload
        return {
            ...state,
            byId: {
                ...state.byId,
                [folder_id]: {
                    ...state.byId[folder_id],
                    loading: true,
                    loaded: false
                }
            }
        }
    },
    [LOADED_SINGLE_FOLDER]: (state, action) => {
        const { folder_id } = action.payload
        return {
            ...state,
            byId: {
                ...state.byId,
                [folder_id]: {
                    ...state.byId[folder_id],
                    loading: false,
                    loaded: true
                }
            }
        }
    }
});

export const fetchFolders = folders => ({
    type: FETCH_FOLDERS,
    payload: {
        folders
    }
})

export const fetchFolderSaga = () => ({
    type: FETCH_FOLDERS_SAGA
})

export const addAdvertiserToFolder = advertiser => ({
    type: ADD_ADVERTISER,
    payload: {
        advertiser
    }
})

export const removeAdvertiserInFolder = advertiser => ({
    type: REMOVE_ADVERTISER_IN_FOLDER,
    payload: {
        advertiser
    }
})

export const addFolder = (folder) => ({
    type: ADD_FOLDER,
    payload: {
        folder
    }
})

export const deleteFolder = (folder) => ({
    type: DELETE_FOLDER,
    payload: {
        folder
    }
})

export const editFolder = (folder) => ({
    type: EDIT_FOLDER,
    payload: {
        folder
    }
})

export const addFolderSaga = (folder) => ({
    type: ADD_FOLDER_SAGA,
    folder
})

export const addFolderAndAdvertiserSaga = (folder) => ({
    type: ADD_FOLDER_AND_ADVERISER_SAGA,
    folder
})

export const editFolderSaga = (folder) => ({
    type: EDIT_FOLDER_SAGA,
    folder
})
export const deleteFolderSaga = (folder) => ({
    type: DELETE_FOLDER_SAGA,
    folder
})

export const loadingFolder = () => ({
    type: LOADING_FOLDER
})

export const loadedFolder = () => ({
    type: LOADED_FOLDER
})

export const toggleFolderModal = (open, folder_id) => ({
    type: TOGGLE_FOLDER_MODAL,
    payload: { open, folder_id }
})

export const loadingSingleFolder = (folder_id) => ({
    type: LOADING_SINGLE_FOLDER,
    payload: {
        folder_id
    }
})

export const loadedSingleFolder = (folder_id) => ({
    type: LOADED_SINGLE_FOLDER,
    payload: { folder_id }
})

export const namespace = 'folder';


// Define selectors
export const getFolders = state => state.folder.allIds.map(folderId => state.folder.byId[folderId]);
export const getFolder = state => folderId => state.folder.byId[folderId];
export const getFolderEditing = state => state.folder.byId.editing || { folder_id: 'editing' };
export const getModalState = state => state.folder.modalOpen;
export const getLoadState = state => state.folder.loaded; 

export default folderReducer;
